import type { PaginatedResponse } from '../types';

/** Invalid success bodies must take the same visible recovery path as errors. */
export function requireArray<T>(value: unknown, label: string): T[] {
  if (!Array.isArray(value))
    throw new Error(`The ${label} response is invalid. Please retry.`);
  return value;
}

export function requireRecord(
  value: unknown,
  label: string,
  stringFields: string[] = [],
): Record<string, any> {
  if (
    !value ||
    typeof value !== 'object' ||
    Array.isArray(value) ||
    stringFields.some(
      (field) => typeof (value as Record<string, unknown>)[field] !== 'string',
    )
  ) {
    throw new Error(`The ${label} response is invalid. Please retry.`);
  }
  return value as Record<string, any>;
}

export function requirePaginatedResponse<T>(
  value: unknown,
  label: string,
  stringFields: string[] = [],
): PaginatedResponse<T> {
  const body = requireRecord(value, label);
  const data = requireArray<T>(body.data, label);
  data.forEach((item) => requireRecord(item, label, stringFields));
  const pagination = requireRecord(body.pagination, `${label} pagination`);
  if (
    !['page', 'limit', 'totalPages'].every(
      (key) => Number.isInteger(pagination[key]) && pagination[key] >= 1,
    ) ||
    !Number.isInteger(pagination.total) ||
    pagination.total < 0
  ) {
    throw new Error(`The ${label} pagination is invalid. Please retry.`);
  }
  return { data, pagination } as PaginatedResponse<T>;
}
